import React from 'react';
import PropTypes from 'prop-types';
// import {BottomOneLevelTableRow, BottomOneLevelItem, BottomOneLevelDetailItem, BottomOneLevelRightItem} from './style/bottom_one_blurry_line_style';
import {
	BottomOneLevelTableRow,
	BottomOneLevelItem,
	BottomOneLevelDetailItem,
	BottomOneLevelRightItem,
} from './style/bottom_one_blurry_line_style';
export const BottomOneLevelBlurryRow = ({
	enabledColumns,
	isVisible,
	bottomOneItems,
	bottomOneRightItems,
	bottomOneDetailItems,
	numberOfParents,
}) => {
	const list = [];
	let index = 0;

	if (isVisible) {
		if (bottomOneItems) {
			//looping through the bottom 2 simple items
			for (const key of Object.keys(bottomOneItems)) {
				if (enabledColumns[key] !== undefined && enabledColumns[key] !== 0) {
					list.push(
						<BottomOneLevelItem order={enabledColumns[key]} key={index}>
							{bottomOneItems[key] !== null && <div className="blurry-text"></div>}
						</BottomOneLevelItem>
					);
					index++;
				}
			}
		}

		if (bottomOneRightItems) {
			//looping through the bottom 2 simple right aligned items
			for (const key of Object.keys(bottomOneRightItems)) {
				if (enabledColumns[key] !== undefined && enabledColumns[key] !== 0) {
					list.push(
						<BottomOneLevelRightItem order={enabledColumns[key]} key={index}>
							{bottomOneRightItems[key] !== null && <div className="blurry-text"></div>}
						</BottomOneLevelRightItem>
					);
					index++;
				}
			}
		}

		if (bottomOneDetailItems) {
			//looping through the bottom 2 flex 1 items
			for (const key of Object.keys(bottomOneDetailItems)) {
				if (enabledColumns[key] !== undefined && enabledColumns[key] !== 0) {
					list.push(
						<BottomOneLevelDetailItem order={enabledColumns[key]} key={index}>
							{bottomOneDetailItems[key] !== null && <div className="blurry-text"></div>}
						</BottomOneLevelDetailItem>
					);
					index++;
				}
			}
		}
	}

	return (
		<>
			<BottomOneLevelTableRow numberOfParents={numberOfParents}>{list}</BottomOneLevelTableRow>
		</>
	);
};

BottomOneLevelBlurryRow.propTypes = {
	isVisible: PropTypes.bool,
	numberOfLevels: PropTypes.bool,
	isFirstRow: PropTypes.bool,
	isExpanded: PropTypes.bool,
	mainItem: PropTypes.object,
	reportedTime: PropTypes.string,
	assigneesElement: PropTypes.object,
	projectName: PropTypes.string,
	roleName: PropTypes.string,
	price: PropTypes.string,
	cost: PropTypes.string,
	notes: PropTypes.string,
	taskName: PropTypes.string,
	personIcon: PropTypes.object,
	timeRegType: PropTypes.string,
	projectIcon: PropTypes.object,
	timeRegDetail: PropTypes.string,
	date: PropTypes.string,
	departmentName: PropTypes.string,
	clientName: PropTypes.string,
	billable: PropTypes.string,
	bottomOneItems: PropTypes.object,
	bottomOneDetailItems: PropTypes.object,
	bottomOneGreyItems: PropTypes.object,
	bottomOneRightItems: PropTypes.object,
	numberOfParents: PropTypes.number,

	enabledColumns: PropTypes.shape({
		needingSpace: PropTypes.bool,
		projectIcon: PropTypes.bool,
		mainItem: PropTypes.bool,
		caretIcon: PropTypes.bool,
		personIcon: PropTypes.bool,
		personName: PropTypes.bool,
		reportedTime: PropTypes.bool,
		timeRegType: PropTypes.bool,
		timeRegDetail: PropTypes.bool,
		projectName: PropTypes.bool,
		roleName: PropTypes.bool,
		price: PropTypes.bool,
		cost: PropTypes.bool,
		date: PropTypes.bool,
		notes: PropTypes.bool,
		taskName: PropTypes.bool,
		showBottom: PropTypes.bool,
		departmentName: PropTypes.bool,
		clientName: PropTypes.bool,
		billable: PropTypes.bool,
	}).isRequired,
};
